import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import banerImage from 'images/detail-of-crop-banner.jpg';
import RealProductSidebar from 'components/RealProductSidebar';
import PictureComponent from 'components/PictureComponent';
import image from 'images/crop-nutrition-programs-info.jpg';

const DetailedOfCropNutrition = () => {
    return (
        <div className="container">
            <Banner title="Cereals" image={banerImage} buttonText="View program" />
            <div className="inner-container section-padding-y">
                <WithSidebar Sidebar={<RealProductSidebar title="Nutrition program for other crops" />}>
                    <div className="box">
                        <PictureComponent srcBig={image} />
                        <h3>Purpose of processing</h3>
                    </div>
                </WithSidebar>
            </div>
        </div>
    );
};

export default DetailedOfCropNutrition;
